import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { render } from 'storyblok-rich-text-react-renderer';
import ApplyNow from '@/components/Buttons/ApplyNow';
import QualificationModal from '@/components/Modal/QualificationModal';
import ConfirmationModal from '@/components/Modal/ConfirmationModal';
import SuccessModal from '@/components/Modal/SuccessModal';

export interface VacancyProps {
  title: string;
  locationLabel: string;
  locationTag: string[];
  jobTypeLabel: string;
  shortJobDescription: string;
  jobTypeDescription: string;
  licenseRequiredLabel: string;
  licenseRequiredDescription: string;
  educationDescription: string;
  educationLabel: string;
  jobDescriptionsBlocks: any;
  applyNow: any;
  hideDesc: boolean;
  setHideDesc: Dispatch<SetStateAction<boolean>>;
  requireSecurityGuard: boolean;
}
export default function Vacancy({
  title,
  locationLabel,
  locationTag,
  jobTypeLabel,
  shortJobDescription,
  jobTypeDescription,
  licenseRequiredLabel,
  licenseRequiredDescription,
  jobDescriptionsBlocks,
  educationLabel,
  educationDescription,
  applyNow,
  hideDesc,
  setHideDesc,
  requireSecurityGuard,
}: VacancyProps) {
  const [showFull, setShowFull] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [email, setEmail] = useState('');

  function ToggleShowDesc() {
    setShowFull(!showFull);
  }
  useEffect(() => {
    if (hideDesc) {
      setShowFull(false);
      setHideDesc(false);
    }
  }, [hideDesc]);

  function onApply() {
    setIsOpenModal(true);
  }

  function onSuccess() {
    setOpenConfirmationModal(false);
    setOpenSuccessModal(true);
    setTimeout(() => {
      setOpenSuccessModal(false);
      setEmail('');
    }, 6000);
  }

  return (
    <>
      {isOpenModal && (
        <QualificationModal
          onClose={() => setIsOpenModal(false)}
          isOpen={isOpenModal}
          requireSecurityGuard={requireSecurityGuard}
          setOpenConfirmationModal={setOpenConfirmationModal}
        />
      )}
      {openConfirmationModal && (
        <ConfirmationModal
          onClose={() => setOpenConfirmationModal(false)}
          isOpen={openConfirmationModal}
          setEmail={setEmail}
          onSuccess={onSuccess}
          position={title}
          location={locationTag}
        />
      )}
      {openSuccessModal && (
        <SuccessModal
          onClose={() => setOpenSuccessModal(false)}
          isOpen={openSuccessModal}
          email={email}
        />
      )}
      <div className='rounded-lg border-[1px] border-main-gray md:p-6 p-2 lg:mb-10 mb-7'>
        <h2 className='text-left text-main-blue font-medium md:mt-0 mt-2 md:text-2xl text-xl'>
          {title}
        </h2>
        <div className='hor-line md:my-6 my-4'></div>
        <div className='flex md:gap-16 gap-4 flex-wrap'>
          <div className='flex flex-col md:w-auto w-[44%]'>
            <p className='text-main-red font-medium mb-2'>{locationLabel}</p>
            <div className='flex'>
              <p className='text-main-neutrals md:text-base text-xs'>
                {locationTag.join(', ')}
              </p>
            </div>
          </div>
          <div className='flex flex-col md:w-auto w-[44%]'>
            <p className='text-main-red font-medium mb-2'>{jobTypeLabel}</p>
            <div className='flex'>
              <p className='text-main-neutrals md:text-base text-xs'>
                {jobTypeDescription}
              </p>
            </div>
          </div>
          <div className='flex flex-col md:w-auto w-[44%]'>
            <p className='text-main-red font-medium mb-2'>
              {licenseRequiredLabel}
            </p>
            <div className='flex'>
              <p className='text-main-neutrals md:text-base text-xs'>
                {licenseRequiredDescription}
              </p>
            </div>
          </div>
          <div className='flex flex-col md:w-auto w-[44%]'>
            <p className='text-main-red font-medium mb-2'>{educationLabel}</p>
            <div className='flex'>
              <p className='text-main-neutrals md:text-base text-xs'>
                {educationDescription}
              </p>
            </div>
          </div>
        </div>
        <div className='hor-line md:my-6 my-4'></div>
        <div className='mb-6'>
          <div className='text-content lg:pr-14 vacancy-content'>
            {render(shortJobDescription)}
            {jobDescriptionsBlocks && showFull && render(jobDescriptionsBlocks)}
          </div>
        </div>
        <div className='flex lg:gap-6 gap-4 md:flex-row flex-col lg:justify-start justify-center'>
          {jobDescriptionsBlocks.content?.length > 1 && (
            <div
              className='button bg-[#510909] text-white md:w-max w-full flex items-center px-4'
              onClick={() => ToggleShowDesc()}
            >
              {showFull
                ? 'See less job description'
                : 'See full job description'}
            </div>
          )}
          <ApplyNow
            onClick={onApply}
            applyNowText={applyNow.apply_now_label}
            className='md:w-[251px] w-full'
          />
        </div>
      </div>
    </>
  );
}
